import { Injectable, ErrorHandler } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
    constructor(private readonly http: HttpClient) {
    }    

    handleError(error: any) {
        if (error instanceof HttpErrorResponse) {
            //Backend returns unsuccessful response codes such as 404, 500 etc.				  
            //console.log('Backend returned status code: ', error.status != undefined ? error.status : 'te');
            //console.log('Response body:');
            //console.log(+ ' , message:' + error.message + ' , Url:' + error.url
            //    + ' , headers:' + error.headers
            //    + ' , StatusText:' + error.statusText
            //    + ' , Error:' + error.error
            //    + ' , ErrorInfo:' + error.toString());

            this.http.get('/api/Login/ApplicationErrorNotification', {
                params: {
                    errormessage: 'server-side error:' + error.status
                        + ' , message:' + error.message + ' , Url:' + error.url
                        + ' , headers:' + error.headers
                        + ' , StatusText:' + error.statusText
                        + ' , Error:' + error.error
                        + ' , ErrorInfo:' + error.toString()
                },responseType: 'text' 
            }).subscribe(result => {
            });
        } else {

            //console.log(+ ' , message:' + error.message + ' , Url:' + error.url
            //    + ' , headers:' + error.headers
            //    + ' , StatusText:' + error.statusText
            //    + ' , Error:' + error.error
            //    + ' , ErrorInfo:' + error.toString());

            //A client-side or network error occurred.	          
            this.http.get('/api/Login/ApplicationErrorNotification', {
                params: {
                    errormessage: 'client-side error:' + error.status
                        + ' , message:' + error.message + ' , Url:' + error.url
                        + ' , headers:' + error.headers
                        + ' , StatusText:' + error.statusText
                        + ' , Error:' + error.error
                        + ' , ErrorInfo:' + error.toString()
                }, responseType: 'text' 
            }).subscribe(result => {
                //console.log(result.json());
            });
        }
    }
} 